/**
 * 一场分镜走到了哪一步：有入库片段就是 stored；否则看最近一次供应商调用；
 * 一次调用都没有说明生产还没轮到它（场次按顺序生成，后一场续接前一场尾帧）。
 */
export function segmentStage(segment) {
  if (segment === null) return 'pending'
  if (segment.clip !== null) return 'stored'
  const latestCall = segment.calls.at(-1)
  return latestCall === undefined ? 'pending' : latestCall.status
}

export function stageVariant(stage) {
  switch (stage) {
    case 'pending':
      return 'neutral'
    case 'submitted':
      return 'info'
    case 'ok':
    case 'stored':
      return 'success'
    case 'error':
      return 'danger'
    default:
      throw new Error(`Unhandled segment stage: ${stage}`)
  }
}

export function callVariant(status) {
  switch (status) {
    case 'submitted':
      return 'info'
    case 'ok':
      return 'success'
    case 'error':
      return 'danger'
    default:
      throw new Error(`Unhandled video call status: ${status}`)
  }
}
